import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Rating from '@components/Rating/Rating';

import styles from './criticReview.scss';

const DIGITS = 'digits';
const USER = 'user';
const GLASSES = 'glasses';

const SCORE_TYPE_MAP = {
  0: DIGITS,
  1: USER,
  2: GLASSES,
};

const CriticReview = ({ criticReview, large }) => {
  if (!criticReview) {
    return null;
  }

  const score = parseFloat(criticReview?.score, 10);
  const scoreMax = criticReview.wine_critic?.score_max;
  const reviewType = SCORE_TYPE_MAP[criticReview.wine_critic?.score_type];

  if (reviewType === DIGITS) {
    return (
      <div
        className={cx(styles.digits, {
          [styles.large]: large,
        })}
      >
        {criticReview.score}
        <span className={styles.max}>/{criticReview.wine_critic.score_max}</span>
      </div>
    );
  }

  return <Rating rating={score} maxRating={scoreMax} theme={reviewType} size={22} />;
};

CriticReview.defaultProps = {
  large: false,
};

CriticReview.propTypes = {
  criticReview: PropTypes.object.isRequired,
  large: PropTypes.bool,
};

export default CriticReview;
